import { useContext, useEffect } from "react";
import { DatabaseSearchContext } from "nystem-components";

const getValue = (item, id) =>
  id.split(".").reduce((value, part) => value && value[part], item);

const byDate = (field) => (a, b) =>
  new Date(getValue(a, field)) - new Date(getValue(b, field));

const countById = (items = []) =>
  items.reduce((values, { id, count }) => {
    values[id] = parseInt(count || 0, 10);
    return values;
  }, {});

const selectFirstLast = (first = [], last = []) => {
  const firstCounts = countById(first);
  const lastCounts = countById(last);

  return [...new Set([...Object.keys(firstCounts), ...Object.keys(lastCounts)])]
    .map((id) => {
      const first = firstCounts[id] || 0;
      const last = lastCounts[id] || 0;
      return { first, id, last };
    })
    .sort((a, b) => b.last - a.last);
};

const ViewListFirstLast = ({ model, view }) => {
  const { search } = useContext(DatabaseSearchContext);
  const items = [...((search && search.data) || [])].sort(
    byDate(model.dateField || "_crdate"),
  );
  const groups = model.groups || [];
  const first = items[0];
  const last = items[items.length - 1];

  const data =
    !first || !last || first === last
      ? []
      : groups.map(({ id, source, text }) => ({
          id,
          rows: selectFirstLast(getValue(first, id), getValue(last, id)),
          source,
          text,
        }));
  const eventData = JSON.stringify(data);

  useEffect(() => {
    const timer = setTimeout(() => {
      view.event(model.event || "firstLast", { data: JSON.parse(eventData) });
    }, 0);

    return () => clearTimeout(timer);
  }, [eventData, model.event, view]);

  return null;
};

export default ViewListFirstLast;
